import { ProcessingOverlay, TwoColumnsLayout } from '@components'

import React, { ReactElement } from 'react'

import { AttachmentShortcuts } from '../AttachmentShortcuts'
import { BillEditableAttachments } from '../BillEditableAttachments'
import { BillEditableForm, useBillForm } from '../BillEditableForm'

export const BillEditableLayout = (): ReactElement => {
  const { processingAction, isFetching, modalDisplayMode } = useBillForm()

  return (
    <>
      {(!!processingAction || isFetching) && <ProcessingOverlay />}
      <TwoColumnsLayout>
        <BillEditableAttachments />
        <BillEditableForm />
      </TwoColumnsLayout>
      {!modalDisplayMode && <AttachmentShortcuts />}
    </>
  )
}
